











































import { Vue, Component, Prop, Model, Emit } from 'vue-property-decorator'
import { BasicModel } from '@/models/Models'
import TableColumn, { ColumnConfig } from './TableColumn.vue'
import { randKey } from '@/utils/random'

export interface Config {
  rowKey: string
  columns: ColumnConfig[]
  total?: number | Function
  height?: number
  maxHeight?: number
  treeprops?: treeConfig
  selection?: 'radio' | 'multi' | 'reserve'
  emptyShow?: string
}
export interface Pagination {
  current: number
  pagesize: number
}

export interface treeConfig {
  children: string
  hasChildren: Boolean
}

@Component({
  components: { TableColumn }
})
export default class Table extends Vue {
  @Prop({ type: Object, required: true }) config!: Config
  @Prop({ type: Object, required: true }) pagination!: Pagination
  @Prop({ type: Array, required: true }) tableData!: Array<BasicModel>

  loading = false
  randKey = randKey()
  get columns() {
    return this.config.columns
  }
  get isSelection() {
    const sel = this.config.selection
    return sel === 'multi' || sel === 'reserve'
  }

  handleSizeChange(size: number) {
    this.$emit('size-change', size)
    this.pagination.pagesize = size
    this.refresh()
  }

  handlePageChange(current: number) {
    this.$emit('page-change', current)
    this.pagination.current = current
    this.refresh()
  }

  async refresh() {
    this.loading = true
    this.$emit('refresh', this.pagination)
  }

  @Emit('row-click')
  clickRow(row: any) {
    return row
  }
  @Emit('click')
  buttonclick($event: any) {
    return $event
  }
}
